export default __webpack_public_path__ + "static/media/ebudgeQr.93149a04.jpg";